import { render, staticRenderFns } from "./CookieWidget.vue?vue&type=template&id=0d07ae02&"
import script from "./CookieWidget.vue?vue&type=script&lang=js&"
export * from "./CookieWidget.vue?vue&type=script&lang=js&"
import style0 from "./CookieWidget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports